import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface UserData {
  username: string;
  slack: string;
  role: string;
  id: number;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(@Inject(HttpClient) private http: HttpClient) {}

  getUser(): Observable<UserData> {
    return this.http.get<UserData>('api/login', { withCredentials: true });
  }

  login(credentials: any): Observable<any> {
    return this.http.post('api/login', credentials, { withCredentials: true });
  }

  changePassword(data: any): Observable<any> {
    return this.http.put('api/login', data, { withCredentials: true });
  }

  // Auth2 functionality (logout)
  logout(): Observable<any> {
    return this.http.get('api/logout', { withCredentials: true });
  }
}
